<template>
  <div>
    <BaseText @input="emitToggleName($event)" :value="nameValue" placeholder="متن را اینجا وارد نمائید" required />
    <div class="d-flex align-items-center mt-3">
      <div class="me-3 title">پیش فرض</div>
      <CheckBox :value="toggleValue" @input="emitToggleValue($event)" />
    </div>
  </div>
</template>

<script>
import BaseText from '@/components/common/form/formModules/BaseText.vue'
import CheckBox from '@/components/common/form/formModules/Checkbox.vue'

export default {
  components: {
    BaseText,
    CheckBox,
  },
  props: {
    nameValue: {
      default: '',
    },
    toggleVal: {
      default: null,
    },
  },
  methods: {
    emitToggleValue(payload) {
      this.$emit('toggleValueChange', payload)
    },
    emitToggleName(payload) {
      this.$emit('toggleNameChange', payload)
    },
  },
  computed: {
    toggleValue() {
      if (this.toggleVal === 'true') {
        return true
      } else if (this.toggleVal === 'false') {
        return false
      } else {
        return this.toggleVal
      }
    },
  },
}
</script>

<style scoped lang="scss">
.title {
  margin-bottom: 8px;
}
</style>
